<template>
    <section class='add-rating-modal'>
        <b-modal :active="true" :canCancel="false">
            <section class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Tilføj ny udtalelse</p>
                </header>

                <section class="modal-card-body">
                    <div class="columns">
                        <div class="column">
                            <b-field :label="$t('students.rating.title')"
                                     :type="{'is-danger': veeErrors.has('title')}"
                                     :message="veeErrors.first('title')">
                                <b-input v-model="rating.title" name="title"
                                         v-validate="'required'" :data-vv-as="$t('students.rating.title')" />
                            </b-field>
                        </div>

                        <div class="column">
                            <b-field :label="$t('students.rating.score')"
                                     :type="{'is-danger': veeErrors.has('score')}"
                                     :message="veeErrors.first('score')">
                                <b-field :addons="false" grouped group-multiline>
                                    <b-radio-button v-for="n in 5" :key="n" v-model="rating.score"
                                        :native-value="n" type="is-primary" name="score"
                                        v-validate="'required'" :data-vv-as="$t('students.rating.score')" >
                                        {{n}}
                                    </b-radio-button>
                                </b-field>
                            </b-field>
                        </div>
                    </div>

                    <div class="columns is-6">
                        <div class="column">
                            <b-field :label="$t('students.rating.name')"
                                     :type="{'is-danger': veeErrors.has('name')}"
                                     :message="veeErrors.first('name')">
                                <b-input v-model="rating.name" name="name"
                                         v-validate="'required'" :data-vv-as="$t('students.rating.name')" />
                            </b-field>
                        </div>

                        <div class="column">
                            <b-field :label="$t('students.rating.position')">
                                <b-input v-model="rating.position" name="position" />
                            </b-field>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <b-field :label="$t('students.rating.body')"
                                     :type="{'is-danger': veeErrors.has('body')}"
                                     :message="veeErrors.first('body')">
                                <b-input v-model="rating.body" type="textarea" name="body"
                                         v-validate="'required'" :data-vv-as="$t('students.rating.body')" />
                            </b-field>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column is-narrow">
                            <b-field :label="$t('students.rating.customer')">
                                <b-select v-model="rating.customer_id"
                                          placeholder="Vælg en kunde"
                                          :loading="!customers.length"
                                          expanded>
                                    <option :value="null">Ingen</option>

                                    <option v-for="customer in customers" :value="customer.id">
                                        {{ customer.name }}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>

                    <p class="is-size-5">{{$t('global.forms.preview')}}</p>
                    <br>
                    <div class="columns">
                        <div class="column is-8">
                            <rating class="preview" :student="student" :rating="rating" :preview="true" />
                        </div>
                    </div>
                </section>

                <footer class="modal-card-foot content-pulled-right">
                    <button class="button" @click="close" type="button">{{$t('global.actions.back')}}</button>

                    <button class="button is-primary" :class="{'is-loading': isSubmitting}" @click="submit" :disabled="veeErrors.any()">{{$t('global.actions.save')}}</button>
                </footer>
            </section>
        </b-modal>
    </section>
</template>

<style lang="scss" scoped>
    @import '../../../../global/styles/variables';

    .preview {
        box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
    }
</style>

<script>
    import RatingService from '@/taskflex/students/services/RatingService';
    import Rating from '@/taskflex/students/components/profile/ratings/Rating';
    import CustomerService from '@/taskflex/customers/services/CustomerService';

    export default {
        data() {
            return {
                isSubmitting: false,
                rating: {
                    customer_id: null,
                    title: null,
                    body: null,
                    name: null,
                    position: null,
                    score: null,
                },
                customers: [],
            };
        },

        mounted() {
            this.loadCustomers();
        },

        props: {
            student: {
                type: Object,
                required: true,
            },
        },

        methods: {
            async submit() {
                if (!await this.$validator.validateAll()) {
                    return;
                }

                this.isSubmitting = true;

                RatingService.create(this.student.id, this.rating, ({ data }) => {
                    this.isSubmitting = false;

                    this.$emit('created', data);
                    this.$emit('close');
                });
            },

            loadCustomers() {
                CustomerService.findAll({}, ({ data }) => {
                    this.customers = data.rows;
                });
            },

            close() {
                this.$emit('close');
            },
        },

        components: {
            Rating,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/administration/components/students/CreateRatingModal.vue